import * as tslib_1 from "tslib";
import { UserManager } from "../../../business/managers/user.manager";
import { FormBuilder, Validators } from "@angular/forms";
import { FormValidatorHelper } from "../../../crossconcern/helpers/validators/formvalidator.helper";
import { AppComponent } from "../../app.component";
import { BaseComponent } from "../../base/base.component";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { finalize } from "rxjs/operators";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { PRIVATE_NURSERY_LIST_ROUTE } from "../../../crossconcern/utilities/properties/routename.property";
var ChangePasswordComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ChangePasswordComponent, _super);
    function ChangePasswordComponent(appComponent, router, location, userManager, formBuilder, validator, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.userManager = userManager;
        _this.formBuilder = formBuilder;
        _this.validator = validator;
        _this.alertUtils = alertUtils;
        _this.changePasswordForm = formBuilder.group({
            "oldPassword": [
                null, ([
                    Validators.required, validator.emailValidator
                ])
            ],
            "newPassword": [
                null, ([
                    Validators.required, validator.passwordValidator
                ])
            ],
            "confirmNewPassword": [
                null, ([
                    Validators.required, validator.passwordMatchValidator
                ])
            ]
        });
        return _this;
    }
    ChangePasswordComponent.prototype.ngOnInit = function () {
        //
    };
    ChangePasswordComponent.prototype.onSubmit = function () {
        var _this = this;
        this.appComponent.startLoading();
        this.userManager.changePassword(this.changePasswordForm.value.oldPassword, this.changePasswordForm.value.newPassword)
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function () {
            _this.userManager.logout();
            _this.goToRouteByName(PRIVATE_NURSERY_LIST_ROUTE);
        });
    };
    return ChangePasswordComponent;
}(BaseComponent));
export { ChangePasswordComponent };
